<template> 
	<v-container fluid @click="close_selection += 1"> 
		<v-row class="ma-0">
			<div class="jbicon">
				<JobBagIcon width="45" height="45"/>
			</div>
		</v-row>
		<v-row class="mx-4" no-gutters>
			<v-col cols="12" md="4">
				<v-card
					outlined 
					tile 
					class="my-4"
				>
					<v-card-title class="grey lighten-4">
						<div class="card_heading">About</div> 
					</v-card-title>
					<v-card-text>
						<div class="card_text my-3">
							Instinct Systems Pty Ltd 1988 -  {{ get_current_year() }}
						</div>
						<div class="card_text">Sales</div>
						<div class="card_text">
							<div><a href="tel:+61281158000">+61 2 8115 8000</a></div>
							<div><a href="mailto:sales@jobbag.com">sales@jobbag.com</a></div>
						</div>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="4">
				<v-card
					outlined 
					tile 
					class="my-4"
					:class="$vuetify.breakpoint.xs ? '':'mx-5'"
				>
					<v-card-title class="grey lighten-4">
						<div class="card_heading">Licence Information</div> 
					</v-card-title>
					<v-card-text class="card_text">
						<div class="version_heading text-body2">JobBag Version {{version_number}}</div>
						<div class="version_details text-body1">Build {{version_build}} VCS {{version}}</div>

						<div class="version_heading text-body2">Licensed to</div>
						<div class="version_details text-body1">{{license_name}}</div>

						<div class="version_heading text-body2">Log on Name</div>
						<div class="version_details text-body1">{{log_on_name}}</div>

						<div class="version_heading text-body2">User Details</div>
						<div class="version_details text-body1">
							Group: {{usergroup}}<br>
							Division: {{division}}<br>
							Licence Type: {{license_type}}
						</div>
						<div class="version_heading text-body2">Download desktop software:</div>
						<v-row class="ma-0">
							<v-col cols="6" md="6" class="text-right pr-1">
								<v-btn
									outlined
									small
									color="primary"
									:disabled="$vuetify.breakpoint.smAndDown"
									:href="installer_links.windows_installer"
								>
									<v-icon left>{{ windows }}</v-icon>Windows
								</v-btn>
							</v-col>
							<v-col cols="6" md="6" class="text-left pl-1">
								<v-btn
									outlined
									small
									color="primary"
									:disabled="$vuetify.breakpoint.smAndDown"
									:href="installer_links.mac_installer"
								>
									<v-icon left>{{ apple }}</v-icon>Mac OS
								</v-btn>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="4">
				<v-card
					outlined 
					tile 
					class="my-4"
				>
					<v-card-title class="grey lighten-4">
						<div class="card_heading">Help</div> 
					</v-card-title>
					<v-card-text class="pa-5">
						<div class="help-text">Have a quick question?</div>
						<v-btn class="white--text text-capitalize mt-5" depressed block color="#605AF6" height="62" href="https://help.jobbag.com" target="_blank">JobBag Knowledge Base</v-btn>
						<div class="help-text mt-5">Can’t find the answer? Contact us at:</div>
						<div class="help-info-container mt-5 py-4">
							<div class="help-info">
								<div class="help-info-line my-1" @click="onClickTel('tel:+61281158090')">
									<TwoTone width="20" height="20" color="rgba(0, 0, 0, 0.54)" class="mr-6"/>
									<div class="help-info-text">
										<span>+61</span>&nbsp;
										<span>2</span>&nbsp;
										<span>8115</span>&nbsp;
										<span>8090</span>
									</div>
								</div>
								<div class="help-info-line my-1" @click="onClickEmail('mailto:support@jobbag.com')">
									<Mail width="20" height="20" color="rgba(0, 0, 0, 0.54)" class="mr-6"/>
									<div class="help-info-text">support@jobbag.com</div>
								</div>
							</div>
						</div>
						<v-btn class="text-capitalize mt-5 mb-1" depressed block outlined :disabled="$vuetify.breakpoint.smAndDown" color="#605AF6" height="62" href="https://get.teamviewer.com/jobbagqs" target="_blank">Download Quick Support app</v-btn>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template> 

<script>
import JobBagIcon from "@/components/icons/jobbag-icon";
import TwoTone from "@/components/icons/two-tone";
import Mail from "@/components/icons/mail";

import { mdiApple, mdiWindows } from "@mdi/js";
import moment from 'moment';

export default {
	name: 'About',
	data() {
		return { 
			installer_links: {
				windows_installer: "",
				mac_installer: ""
			},
			apple: mdiApple,
			windows: mdiWindows,
			version: "",
			license: {},
		}
	},
	computed: {
		log_on_name() {
			let user=this.$store.state.user;
			if (user==null){
				return "";
			} else { 
				return user.logon
			}
		},
		version_number() {
			if (this.version==""){
				return "";
			} else{
				return this.version.substr(0,1)+"."+this.version.substr(1,1);
			}
		},
		version_build() {
			if (this.version==""){
				return 0;
			} else{
				return parseInt(this.version.substr(2,3));
			}
		},
		license_name() {
			if (this.license.hasOwnProperty("license_name")){
				return this.license.license_name
			} else{
				return "..."
			}
		},
		usergroup() {
			let user=this.$store.state.user;
			if (user==null){
				return "";
			} else { 
				return user.usergroup.display_name
			}
		},
		division() {
			let user=this.$store.state.user;
			if (user==null){
				return "";
			} else { 
				return user.division.display_name
			}
		},
		license_type() {
			let user=this.$store.state.user;
			if (user==null){
				return "";
			} else { 
				return user.license_type
			}
		},

	},
	created() {
		this.get_download_links();
		this.get_version();
		this.get_license();
	},
	methods: {
		get_download_links() {
			let self = this; // make sure we can access this inside of our promisses
			axios
				.post("/api/installers/listbuildinfo", {
				})
				.then(function(d) {
					let data = d.data;
					if (data.Status == "OK") {
						self.installer_links.windows_installer = data.Windows_installer;
						self.installer_links.mac_installer = data.Mac_installer;
					}
				});
		},
		get_version() {
			let self = this;
			axios
				.get("/oauth/version")
				.then(function(d) {
					self.version=""+d.data.jobbag_version;
				})
				.catch(function(e) {
					console.log(e);
					// self.errormsg = e.message; 
				});
		},
		get_license() {
			let self = this;
			axios
				.get("/api/support/license",{
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let data = d.data;
					if (data.status == "OK") {
						self.license=data.data;
					}
				})
				.catch(function(e) {
					console.log(e);
					// self.errormsg = e.message; 
				});
		},
		get_current_year() {
			return moment().format('YYYY');
		},
		onClickTel(tel_text) {
			location.href = tel_text;
		},
		onClickEmail(mail_text) {
			location.href = mail_text;
		}
	},
	components: {
		JobBagIcon,
		TwoTone,
		Mail
	}
}
</script>
<style lang="scss" scoped>
.container {
	width: 100%;
	margin: 0 auto;
	padding: 0px;
	color: rgba(25, 42, 62, 0.1);
}
.jbicon {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100px;
	background: #ffffff;
}
.card_heading {
	color: #192a3e;
	padding: 0 10px;
	word-wrap: normal;
}
.card_text {
	color: #192a3e;
	padding: 0 10px;
}
.version_heading {
	color: #192a3e; 
	opacity: 0.7;
	padding-top: 10px;
	padding-left: 13px;
	padding-right: 13px;
}
.version_details {
	color: #192a3e;
	padding-bottom: 10px;
	padding-left: 13px;
	padding-right: 13px;
}
.version_details_unavailable {
	color: #EE0202;
	padding-bottom: 10px;
	padding-left: 13px;
	padding-right: 13px;
}
.help-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: rgba(25, 42, 62, 0.7);
}
.help-info-container {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
	background: #FAFAFA;
	border-radius: 10px;
}
.help-info {
	display: flex;
	flex-flow: column nowrap;
}
.help-info-line {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	&:hover {
		cursor: pointer;
	}
}
.help-info-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 700;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: 0.5px;
	color: #605AF6;
}
</style>